import { TextInput } from "@circleco/compass/components/TextInput";
import type { FieldError } from "react-hook-form";
import { get, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

const BUSINESS_NAME_FIELD_NAME =
  "community_member_billing_info_attributes[business_name]";

export const CheckoutFormBusinessNameField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const businessNameRegistration = register(BUSINESS_NAME_FIELD_NAME, {
    maxLength: 200,
  });
  const businessNameError = get(errors, BUSINESS_NAME_FIELD_NAME) as
    | FieldError
    | undefined;

  return (
    <TextInput
      {...businessNameRegistration}
      invalid={!!businessNameError}
      error={
        businessNameError &&
        t(
          `paywall_checkout.form.errors.${BUSINESS_NAME_FIELD_NAME}_${businessNameError.type}`,
        )
      }
      label={`${t("paywall_checkout.form.fields.business_name")} (${t(
        "paywall_checkout.form.fields.optional",
      ).toLowerCase()})`}
      data-testid={`checkout-form-${BUSINESS_NAME_FIELD_NAME}-input`}
    />
  );
};
